import { Provider } from "react-redux";
import { PropTypes } from "prop-types";
import React from "react";
import { CustomerManagementRouter } from "./router";
import "@coverme/table/dist/styles/Table-V2.scss";
import "./styles/main.scss";

export const App = ({ store, config }) => {
    return (
        <Provider store={store}>
            <CustomerManagementRouter config={config} />
        </Provider>
    );
};

App.propTypes = {
    store: PropTypes.object,
    config: PropTypes.object,
};
